export default "__VITE_ASSET__00cholf$__"